export const STANDARD_FONT = "STANDARD_FONT";
export const CUSTOM_FONT_1 = "CUSTOM_FONT_1";
export const CUSTOM_FONT_2 = "CUSTOM_FONT_2";

export const DARK_THEME = "DARK_THEME";
export const LIGHT_THEME = "LIGHT_THEME";

export const HIGHLIGHT_COLOR_RED = "HIGHLIGHT_COLOR_RED";
export const HIGHLIGHT_COLOR_GREEN = "HIGHLIGHT_COLOR_GREEN";
export const HIGHLIGHT_COLOR_YELLOW = "HIGHLIGHT_COLOR_YELLOW";
export const HIGHLIGHT_COLOR_ORANGE = "HIGHLIGHT_COLOR_ORANGE";
export const HIGHLIGHT_COLOR_PURPLE = "HIGHLIGHT_COLOR_PURPLE";
export const HIGHLIGHT_COLOR_BLUE = "HIGHLIGHT_COLOR_BLUE";
export const HIGHLIGHT_COLOR_LIGHT_BLUE = "HIGHLIGHT_COLOR_LIGHT_BLUE";
export const HIGHLIGHT_COLOR_DARK_BLUE = "HIGHLIGHT_COLOR_DARK_BLUE";
export const HIGHLIGHT_COLOR_DARK_GREY = "HIGHLIGHT_COLOR_DARK_GREY";
export const HIGHLIGHT_COLOR_WHITE = "HIGHLIGHT_COLOR_WHITE";
export const HIGHLIGHT_COLOR_BLACK = "HIGHLIGHT_COLOR_BLACK";

export const SET_THEME = "SET_THEME";

export const RESET_REDUCER = "RESET_REDUCER";

export const SET_CURRENT_USER_DATA = "SET_CURRENT_USER_DATA";
export const CLEAR_CURRENT_USER_DATA = "CLEAR_CURRENT_USER_DATA";
export const SET_FIRM_ID = "SET_FIRM_ID";
export const SET_CURRENT_USER_IMAGE = "SET_CURRENT_USER_IMAGE";

export const SET_SERVER_ERROR = "SET_SERVER_ERROR";
export const CLEAR_SERVER_ERROR = "CLEAR_SERVER_ERROR";

export const SET_HAS_EDITABLE_CONTENT = "SET_HAS_EDITABLE_CONTENT";

export const MARK_PLAN_LIST_VALID = "MARK_PLAN_LIST_VALID";
export const MARK_PLAN_LIST_INVALID = "MARK_PLAN_LIST_INVALID";

export const SHOW_TIMEOUT_MODAL = "SHOW_TIMEOUT_MODAL";
export const HIDE_TIMEOUT_MODAL = "HIDE_TIMEOUT_MODAL";
export const SHOW_SSO_MODAL = "SHOW_SSO_MODAL";
export const HIDE_SSO_MODAL = "HIDE_SSO_MODAL";
export const SET_MENU_STATE_ADVISOR = "SET_MENU_STATE_ADVISOR";
export const SET_MENU_STATE_ADMIN = "SET_MENU_STATE_ADMIN";
export const SET_MENU_STATE_SUPERADMIN = "SET_MENU_STATE_SUPERADMIN";
export const SET_MENU_STATE_SWITCH_USER = "SET_MENU_STATE_SWITCH_USER";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SET_SIDE_MENU_COLLAPSED = "SET_SIDE_MENU_COLLAPSED";
export const SET_SIDE_MENU_EXPANDED = "SET_SIDE_MENU_EXPANDED";
export const SHOW_USER_PROFILE_MODAL = "SHOW_USER_PROFILE_MODAL";
export const HIDE_USER_PROFILE_MODAL = "HIDE_USER_PROFILE_MODAL";
export const SHOW_PLAN_CREATION_MODAL = "SHOW_PLAN_CREATION_MODAL";
export const HIDE_PLAN_CREATION_MODAL = "HIDE_PLAN_CREATION_MODAL";
export const UPDATE_PLAN_CREATION_ID = "UPDATE_PLAN_CREATION_ID";

export const SHOW_SUCCESS_NOTIFICATION = "SHOW_SUCCESS_NOTIFICATION";
export const CLEAR_SUCCESS_NOTIFICATION = "CLEAR_SUCCESS_NOTIFICATION";
export const SHOW_DELETE_NOTIFICATION = "SHOW_DELETE_NOTIFICATION";
export const CLEAR_DELETE_NOTIFICATION = "CLEAR_DELETE_NOTIFICATION";

export const SET_ADMIN_DEFAULT_PLAN_SETTINGS =
  "SET_ADMIN_DEFAULT_PLAN_SETTINGS";
export const UPDATE_ADMIN_DEFAULT_INFLATION = "UPDATE_ADMIN_DEFAULT_INFLATION";
export const UPDATE_ADMIN_PLAN_SIMULATION = "UPDATE_ADMIN_PLAN_SIMULATION";
export const UPDATE_ADMIN_CLIENT_KEY_DATES = "UPDATE_ADMIN_CLIENT_KEY_DATES";
export const UPDATE_ADMIN_TRACKING_THRESHOLDS =
  "UPDATE_ADMIN_TRACKING_THRESHOLDS";

export const SET_ADVISOR_DEFAULT_PLAN_SETTINGS =
  "SET_ADVISOR_DEFAULT_PLAN_SETTINGS";
export const UPDATE_ADVISOR_DEFAULT_INFLATION =
  "UPDATE_ADVISOR_DEFAULT_INFLATION";
export const UPDATE_ADVISOR_PLAN_SIMULATION = "UPDATE_ADVISOR_PLAN_SIMULATION";
export const UPDATE_ADVISOR_CLIENT_KEY_DATES =
  "UPDATE_ADVISOR_CLIENT_KEY_DATES";
export const UPDATE_ADVISOR_TRACKING_THRESHOLDS =
  "UPDATE_ADVISOR_TRACKING_THRESHOLDS";

export const SHOW_ADD_ALLOCATION_MODEL = "SHOW_ADD_ALLOCATION_MODEL";

export const SET_CURRENT_CLIENT = "SET_CURRENT_CLIENT";
export const SET_CURRENT_COCLIENT = "SET_CURRENT_COCLIENT";
export const SET_CURRENT_FAMILY = "SET_CURRENT_FAMILY";
export const SET_CURRENT_FAMILY_MEMBER = "SET_CURRENT_FAMILY_MEMBER";
export const REMOVE_COCLIENT = "REMOVE_COCLIENT";
export const REMOVE_FAMILY_MEMBER = "REMOVE_FAMILY_MEMBER";
export const REMOVE_ALL_FAMILY_MEMBER = "REMOVE_ALL_FAMILY_MEMBER";
export const ADD_FAMILY_MEMBER = "ADD_FAMILY_MEMBER";

export const SHOW_ADD_FEE_MODEL = "SHOW_ADD_FEE_MODEL";

export const SET_TRIAL_ACCOUNT = "SET_TRIAL_ACCOUNT";

export const SHOW_SECURITY_QUESTION_MODAL = "SHOW_SECURITY_QUESTION_MODAL";
export const HIDE_SECURITY_QUESTION_MODAL = "HIDE_SECURITY_QUESTION_MODAL";

export const EXPENSE_ROW = "EXPENSE_ROW";
export const GOAL_ROW = "GOAL_ROW";

export const UPDATE_WINDOW_SIZE = "UPDATE_WINDOW_SIZE";
export const UPDATE_WINDOW_POSITION = "UPDATE_WINDOW_POSITION";

export const UPDATE_FONT = "UPDATE_FONT";
export const UPDATE_DISPLAY_MODE = "UPDATE_DISPLAY_MODE";
export const UPDATE_HIGHLIGHT_COLOR = "UPDATE_HIGHLIGHT_COLOR";

export const SET_CLIENT_WIZARD_VISIBILITY = "SET_CLIENT_WIZARD_VISIBILITY";

export const TRIGGER_CLIENT_LIST_REFRESH = "TRIGGER_CLIENT_LIST_REFRESH";

export const SYSTEM_WIDE_INFLATION = "SYSTEM_WIDE_INFLATION";
export const INDIVIDUAL_VALUES = "INDIVIDUAL_VALUES";

export const SET_WIDGET_DYNAMIC_DASHBOARD = "SET_WIDGET_DYNAMIC_DASHBOARD";
